/* ------------------------------------------------------------------------ */
/*		File: Banner.tsx                                                    */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

import React, { useEffect, useState } from "react";
import crypt from "crypto-js";
import "../../pages/NavbarHeader/navbarheader.css";
import Popup from "../cmpPopup/cmpPopup";



const Banner: React.FC = () => {
    const [campaign, setCampaign] = useState<any[] | null>(null);
    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const [url, setUrl] = useState<string>();
    const [index, setIndex] = useState<number>(-1);
    const [popupContent, setPopupContent] = useState<any>(null);
    
    /* ------------------------------------------------------------------------ */
    
    useEffect(() => {
        let tmpCampaign = window.localStorage.getItem("campaign");

        let items:any[] = [];

        if (tmpCampaign && tmpCampaign !== null) {
            tmpCampaign = JSON.parse(crypt.AES.decrypt(tmpCampaign, process.env.REACT_APP_ENCRYPTKEY!).toString(crypt.enc.Utf8));

            if (Array.isArray(tmpCampaign)) {
                items = [...tmpCampaign];
                setCampaign(items);
                setUrl(items[0].url);
                setIndex(0);
            }
        }
        return () => {
            setCampaign(null);
        }
    }, [])

    /* ------------------------------------------------------------------------ */
    
    useEffect(() => {
        if (openPopup) return;
        let interval: NodeJS.Timeout;
        if (campaign !== null)
        interval = setInterval(() => {
            if (index === campaign.length - 1) {
                setIndex(0);
                setUrl(campaign[0].url);
            } else {
                setIndex(index + 1);
                setUrl(campaign[index + 1].url);
            }
        }, 5000);
        return () => {
            clearInterval(interval);
        }
    }, [index, openPopup])

    /* ------------------------------------------------------------------------ */  
    
    const handlePopupOpen = () => {
        setPopupContent(campaign![index]); 
        setOpenPopup(true);
    };

    /* ------------------------------------------------------------------------ */
    
    return (
        <div className="banner">
            {campaign && campaign !== null && (
                <img
                    style={{
                        cursor: "pointer"
                    }}
                    src={url}
                    alt=""
                    onClick={handlePopupOpen}
                />
            )}
            {openPopup && (
                <Popup
                    content={popupContent}
                    type="campaign"
                    popupOptions={undefined}
                    handleClose={() => setOpenPopup(false)}
                />
            )}
        </div>
    );
};
export default Banner;